const Q = require('Q');
const _ = require('lodash');
const CATEGORIES = require('../enums/review-category-enum');
function ReviewsByShopper(ReviewService, $state, $stateParams) {
	this.reviewService = ReviewService;
	this.$state = $state;
	this.$stateParams = $stateParams;
}

ReviewsByShopper.prototype.get = function (request, options, bazaarvoiceCallEnabled) {
	const deferred = Q.defer();
	const model = {};
	const previous = this.$state.previous;
    const url = request.url || previous.route.name;

	model.category = !_.isUndefined(request.url) ? CATEGORIES.MY_ACCOUNT.DISPLAY :
		_.includes(url, CATEGORIES.PRODUCT.URL) ? CATEGORIES.PRODUCT.DISPLAY :
		_.includes(url, CATEGORIES.STORE.URL) ? CATEGORIES.STORE.DISPLAY : '';

	model.returnHref = this.$state.href(url, previous.routeParams);
	model.viewMoreHref = this.$state.href(`${url}.reviews`, this.$stateParams); // only applies to my-account
	if (bazaarvoiceCallEnabled) {
		this.reviewService.getBVReviewsByShopperId(request, options).then((productReview) => {
			model.overall = productReview.overall;
			model.reviews = productReview.reviews;
			deferred.resolve(model);
		});
	} else {
		this.reviewService.getByShopperId(request, options).then((productReview) => {
			model.overall = productReview.overall;
			model.reviews = productReview.reviews;
			deferred.resolve(model);
		});
	}

	return deferred.promise;
};

module.exports = ReviewsByShopper;


/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/customer-reviews/factory/reviews-by-shopper.js
 **/